export enum ContactListViewTab {
  COMPANIES = 'companies',
  CONTACTS = 'contacts',
  LOCATIONS = 'locations',
}
